export default {
  // Creatable entries: label, command description, launcher hint
  emailLabel: 'Email',
  emailDescription: 'Create email',
  agentLabel: 'Agent',
  chatDescription: 'Create agent chat',
  chatHint: 'New agent session',
  agentDescription: 'Create agent session',
  agentHint: 'Dedicated Agent Session',
  routineLabel: 'Routine',
  routineDescription: 'Run a model or agent on a schedule or Atlas activity',
  routineHint: 'Schedules and activity triggers',
  databaseLabel: 'Database',
  databaseDescription: 'Create database',
  databaseHint: 'Tables and boards',
  formLabel: 'Form',
  formDescription: 'Create form',
  formHint: 'Questions answered into a database',
  skillLabel: 'Skill',
  skillDescription: 'Create skill',
  skillHint: 'Custom agent skill',
  documentLabel: 'Document',
  documentDescription: 'Create doc',
  taskLabel: 'Task',
  taskDescription: 'Create task',
  projectLabel: 'Project',
  projectDescription: 'Create project',
  snippetLabel: 'Snippet',
  snippetDescription: 'Create snippet',
  snippetHint: 'Reusable document template',
  messageLabel: 'Message',
  messageDescription: 'Create message',
  messageHint: 'Quick send message',
  channelLabel: 'Channel',
  channelDescription: 'Create channel',
  channelHint: 'Team-wide or group chat',
  canvasLabel: 'Canvas',
  canvasDescription: 'Create canvas',
  photoshopLabel: 'Photoshop file',
  photoshopDescription: 'New Photoshop file',
  photoshopHint: 'Layered image editing, saved as .psd',
  designLabel: 'Design',
  designDescription: 'Create design',
  designHint: 'Figma-compatible canvas for UI and graphics',
  illustratorLabel: 'Illustrator file',
  illustratorDescription: 'Create Illustrator file',
  illustratorHint: 'Vector artwork on artboards, saved as .ai',
  spreadsheetLabel: 'Spreadsheet',
  spreadsheetDescription: 'Create spreadsheet',
  spreadsheetHint: 'Tables, formulas, and shared calculations',
  folderLabel: 'Folder',
  folderDescription: 'Create folder',
  codeLabel: 'Code',
  codeDescription: 'Create code file',
  callLabel: 'Call',
  callDescription: 'New Call',
  noteLabel: 'Note',
  aiChatLabel: 'AI',
  companyLabel: 'Company',
  contactLabel: 'Contact',
  pipelineLabel: 'Pipeline',

  // Launcher chrome and hotkeys
  createNew: 'Create New',
  searchCreateOptions: 'Search create options',
  searchMode: 'Search mode',
  descriptionInNewSplit: '{{description}} in new split',
  closeLauncher: 'Close Launcher',
  navigateUp: 'Navigate up',
  navigateDown: 'Navigate down',
  toggleSearchMode: 'Toggle search mode',
  exit: 'Exit',
  openInNewSplit: 'Open in new split',
  openInCurrentSplit: 'Open in current split',
  navigate: 'Navigate',
  create: 'Create',
  choose: 'Choose',
  hold: 'Hold',
  newSplit: 'New split',
  results: 'Results',
  couldNotCreateDatabase: 'Could not create the database',
  couldNotCreateForm: 'Could not create the form',

  // Create menu groups
  groupDocsLabel: 'Docs',
  groupDocsTagline: 'Write and template',
  groupOrganizationLabel: 'Organization',
  groupOrganizationTagline: 'Keep related work together',
  groupDesignLabel: 'Design',
  groupDesignTagline: 'Diagram, sketch, design',
  groupDataLabel: 'Data',
  groupDataTagline: 'Collect, organize, analyze',
  groupCommsLabel: 'Comms',
  groupCommsTagline: 'Reach people',
  groupTasksLabel: 'Tasks',
  groupTasksTagline: 'Stay on top of the work',
  groupAiLabel: 'AI',
  groupAiTagline: 'Put agents to work',
  groupOtherLabel: 'Other',
  groupOtherTagline: 'Everything else',
  groupRecentLabel: 'Recents',
  groupRecentTagline: 'Recently used',

  // Create menu details: tagline, description, examples, short caption
  documentTagline: 'Rich-text doc, edited live together',
  documentDetails:
    'Write notes, specs and ideas together in one place.\nAdd tables, embeds, comments and AI edits.',
  documentExample1: 'Meeting notes',
  documentExample2: 'Product spec',
  documentExample3: 'Team wiki',
  documentShortTagline: 'Collaborative writing',
  snippetTagline: 'Reusable template for your writing',
  snippetDetails:
    'Save templates, checklists and your go-to replies.\nReuse your familiar content in new documents.',
  snippetExample1: 'Doc template',
  snippetExample2: 'Checklist',
  snippetExample3: 'Canned reply',
  snippetShortTagline: 'Reusable template',
  codeTagline: 'Code file with syntax highlighting',
  codeDetails:
    'Create a source file for scripts, queries or config.\nWrite in the language that best fits your work.',
  codeExample1: 'Python script',
  codeExample2: 'SQL query',
  codeExample3: 'Config file',
  codeShortTagline: 'Syntax-highlighted file',
  folderTagline: 'Keep related files together',
  folderDetails:
    'Keep related documents and files in one place.\nOrganize folders and share them together.',
  folderExample1: 'Client files',
  folderExample2: 'Archive',
  folderExample3: 'Team drive',
  folderShortTagline: 'Keep files together',
  canvasTagline: 'Whiteboard for diagrams and sketches',
  canvasDetails:
    'Map out ideas on an infinite shared whiteboard.\nSketch flows, diagrams and connections.',
  canvasExample1: 'Flowchart',
  canvasExample2: 'Mind map',
  canvasExample3: 'Architecture diagram',
  canvasShortTagline: 'Diagrams & whiteboard',
  designTagline: 'Figma-compatible design editor',
  designDetails:
    'Design interfaces and graphics with vector tools.\nBuild with frames and save as a Figma file.',
  designExample1: 'App mockup',
  designExample2: 'Social graphic',
  designExample3: 'Design system',
  designShortTagline: 'Figma-compatible editor',
  databaseTagline: 'Structured records in tables and boards',
  databaseDetails:
    'Organize records with fields that fit your work.\nExplore your data in tables and boards.',
  databaseExample1: 'CRM',
  databaseExample2: 'Content calendar',
  databaseExample3: 'Inventory',
  databaseShortTagline: 'Tables & boards',
  spreadsheetTagline: 'Excel-style workbook with formulas',
  spreadsheetDetails:
    'Build shared spreadsheets for budgets and models.\nUse formulas, multiple sheets and AI edits.',
  spreadsheetExample1: 'Budget',
  spreadsheetExample2: 'Financial model',
  spreadsheetExample3: 'Tracker',
  spreadsheetShortTagline: 'Formulas & sheets',
  formTagline: 'Collect responses',
  formDetails:
    'Collect feedback, requests and survey responses.\nSave every answer directly into your database.',
  formExample1: 'Survey',
  formExample2: 'Intake form',
  formExample3: 'Feedback',
  photoshopTagline: 'Layered image editing',
  photoshopDetails:
    'Create layered images, photo edits and graphics.\nSave your work as a layered Photoshop file.',
  photoshopExample1: 'Photo edit',
  photoshopExample2: 'Composite',
  photoshopExample3: 'Banner',
  illustratorTagline: 'Vector artwork',
  illustratorDetails:
    'Draw scalable logos, icons and vector illustrations.\nWork on artboards and save an Illustrator file.',
  illustratorExample1: 'Logo',
  illustratorExample2: 'Illustration',
  illustratorExample3: 'Icon set',
  emailTagline: 'Compose from your connected inbox',
  emailDetails:
    'Write and send email from your connected inbox.\nDraft and refine each message with AI help.',
  emailExample1: 'Follow-up',
  emailExample2: 'Intro',
  emailExample3: 'Update to a client',
  emailShortTagline: 'Compose from inbox',
  messageTagline: 'Quick DM to a person or group',
  messageDetails:
    'Start a direct conversation with your teammates.\nSend a quick note to one person or a group.',
  messageExample1: 'Quick question',
  messageExample2: 'Heads-up',
  messageExample3: 'Group DM',
  messageShortTagline: 'Quick DM',
  channelTagline: 'Ongoing space for a team or topic',
  channelDetails:
    'Give your team or project a shared conversation.\nKeep threads and files together in one place.',
  channelExample1: '#design',
  channelExample2: '#launch',
  channelExample3: '#support',
  channelShortTagline: 'Team discussion',
  callTagline: 'Start an audio or video call',
  callDetails:
    'Bring people together for an audio or video call.\nInvite teammates and guests to join you live.',
  callExample1: 'Quick sync',
  callExample2: 'Pairing',
  callExample3: 'Customer call',
  callShortTagline: 'Audio or video',
  taskTagline: 'To-do with owner, status and due date',
  taskDetails:
    'Turn a piece of work into a task with a clear owner.\nSet a due date and follow it through to done.',
  taskExample1: 'Bug',
  taskExample2: 'Follow-up',
  taskExample3: 'Review request',
  taskShortTagline: 'Track work',
  projectTagline: 'Group tasks toward a shared goal',
  projectDetails:
    'Bring related tasks together around a shared goal.\nKeep track of progress across your project.',
  projectExample1: 'Launch',
  projectExample2: 'Quarterly goal',
  projectExample3: 'Migration',
  projectShortTagline: 'Organize related tasks',
  reminderTagline: 'Nudge yourself at a time you pick',
  reminderDetails:
    'Set a reminder for something you want to revisit.\nChoose a time and let Atlas bring it back.',
  reminderExample1: 'Call back',
  reminderExample2: 'Check in Friday',
  reminderExample3: 'Renew license',
  reminderShortTagline: 'Nudge yourself later',
  agentTagline: 'AI session that researches, writes and codes',
  agentDetails:
    'Start an AI session to move your work forward.\nResearch a topic, draft content or write code.',
  agentExample1: 'Research a topic',
  agentExample2: 'Draft a doc',
  agentExample3: 'Fix a bug',
  agentShortTagline: 'Dedicated agent session',
  routineTagline: 'Run an agent on a schedule or trigger',
  routineDetails:
    'Put recurring work on a schedule or a trigger.\nLet an agent take care of it automatically.',
  routineExample1: 'Daily digest',
  routineExample2: 'Triage inbox',
  routineExample3: 'Weekly report',
  routineShortTagline: 'Automate recurring work',
  skillTagline: 'Reusable instructions for agents',
  skillDetails:
    'Give agents reusable instructions for your work.\nDefine a process, style or preferred approach.',
  skillExample1: 'Brand voice',
  skillExample2: 'PR review',
  skillExample3: 'Report format',
  skillShortTagline: 'Reusable agent instructions',

  // Detailed and carousel launchers
  createOptions: 'Create options',
  noMatchingCreateOptions: 'No matching create options',
  itemDetails: '{{label}} details',
  shortcut: 'Shortcut',
  shortcutThen: 'then',
  createItem: 'Create {{label}}',
  createItemInNewSplit: 'Create {{label}} in new split',
  createInNewSplit: 'Create in new split',
  previousCreateOption: 'Previous create option',
  nextCreateOption: 'Next create option',
  browseCreateOptions: 'Browse create options {{start}}–{{end}}',

  // Mobile sheet
  createNewSheetTitle: 'Create new',
  closeCreateMenu: 'Close create menu',

  // Create menu preview
  searchLayoutCreateOptions: 'Search {{layout}} create options',
  noMatchesFor: 'No matches for “{{query}}”',
  clearSearch: 'Clear search',

  // Command menu
  createNewProject: 'Create new project',

  // Per-view create menus
  new: 'New',
  newFileOrFolderIn: 'New file or folder in {{destination}}',
  createIn: 'Create in',
  createInName: 'Create in {{name}}',
  uploadFiles: 'Upload files',
  uploadFolder: 'Upload folder',
  importFile: 'Import file',
  importFolder: 'Import folder',
  createCrmRecord: 'Create CRM record',
  createInFolder: 'Create in folder',
  failedToCreateSpreadsheet: 'Failed to create spreadsheet',
  failedToCreateMarkdownFile: 'Failed to create markdown file',
  failedToCreateTask: 'Failed to create task',
  failedToCreateChat: 'Failed to create chat',
  failedToCreateCanvas: 'Failed to create canvas',
  failedToCreatePhotoshopFile: 'Failed to create Photoshop file',
  failedToCreateDesign: 'Failed to create design',
  failedToCreateIllustratorFile: 'Failed to create Illustrator file',
  failedToCreateFolder: 'Failed to create folder',

  // Guided create menus: a title and a one-line description per choice.
  eventLabel: 'Event',
  bookingLinkLabel: 'Booking link',
  subtaskLabel: 'Subtask',
  tagLabel: 'Tag',
  conversationLabel: 'Conversation',
  workAgentLabel: 'Work agent',
  codingAgentLabel: 'Coding agent',
  guideEvent: 'Schedule a meeting or block time on your calendar.',
  guideCall: 'Start a live call now and invite others to join.',
  guideBookingLink:
    'Share your availability so others can book a time with you.',
  guideTask: 'Track a standalone piece of work.',
  guideSubtask: 'Choose a parent task and break its work into a smaller step.',
  guideProject: 'Group related tasks around a shared goal.',
  guideTag: 'Label work so you can organize and filter it across projects.',
  guideConversation: 'Start a conversation with an existing agent.',
  guideWorkAgent:
    'Create an assistant with instructions and access to your Atlas workspace.',
  guideCodingAgent: 'Create an agent that works in a connected coding harness.',
  guideRoutine: 'Set up an agent to run on a recurring schedule.',
  guideCompany:
    'Track an organization, its people, and your relationship with it.',
  guideContact:
    'Keep a person’s details and activity connected to their company.',
  guidePipeline:
    'Move records through stages to track deals or another repeatable process.',
  guideUploadFiles: 'Bring existing files from your computer into this folder.',
  guideUploadFolder: 'Import a folder and the files inside it.',
  guideDocument: 'Write and collaborate on notes, plans, or longer documents.',
  guideSnippet: 'Save a reusable piece of text or code for later.',
  guideSpreadsheet: 'Work with tables, formulas, and structured numbers.',
  guideCanvas: 'Sketch ideas and arrange information on a shared canvas.',
  guideCode: 'Write and edit code in a dedicated file.',
  guideFolderProject: 'Keep related files and work together in one place.',
  guideDatabase: 'Organize records with custom fields and views.',
  guideForm: 'Collect structured responses through a shareable form.',
  guideInThisFolder: 'Create one in this folder.',
};
